export default __webpack_public_path__ + "assets/mexico-flag.png";